/*
  Bridges the create-event modal (writer) and the dashboard banner (reader)
  across the post-duplication redirect. Keyed by the new event's id so the
  banner survives a page reload while the async copy job runs.
*/
const storageKey = eventId => `duplication-job:${eventId}`;

export const setDuplicationJobId = (eventId, jobId) => {
  if (eventId && jobId) sessionStorage.setItem(storageKey(eventId), String(jobId));
};

export const getDuplicationJobId = eventId =>
  eventId ? sessionStorage.getItem(storageKey(eventId)) : null;

export const clearDuplicationJobId = eventId => {
  if (eventId) sessionStorage.removeItem(storageKey(eventId));
};
